import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=97de828e"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=97de828e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports